module.exports = __webpack_public_path__ + "static/img/s36.89bf9cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/resourceShow/img/zh/s36.png
// module id = Utvr
// module chunks = 3